<mat-select [formControl]="skjemakontroll" [compareWith]="erValgt" panelClass="velg-tema--alternativer" [placeholder]="placeholder" data-testid="tema" #temavelger>
  <mat-select-tips>
    {{ "Tema er en overordnet gruppering av sakene. Gruppering gir deg muligheten til å strukturere sakene i et hierarki. Eksempler på Tema er Økonomi, Prosjekt X, Produksjon, Marked, o.s.v.."|translate }}
  </mat-select-tips>
  @for (tema of aktiveTemaer; track tema.id) {
    <mat-option [value]="tema">{{ tema.navn }}</mat-option>
  }
  <mat-option value="null" class="mat-option--skillelinje-over"><span>{{ "ikke angitt"|translate }}</span></mat-option>
  @if (arkiverteTemaer?.length > 0 && !viserArkiverte) {
    <div (click)="visArkiverte()" class="mat-mdc-option mdc-list-item mat-option--skillelinje-over vis-arkiverte">
      {{ "Vis {antall} arkivert tema"|translate: {antall:arkiverteTemaer.length} }}
    </div>
  }
  @if (viserArkiverte) {
    <mat-optgroup label="{{'Arkiverte temaer'|translate}}" class="mat-option--skillelinje-over">
      @for (tema of arkiverteTemaer; track tema.id) {
        <mat-option [value]="tema">{{ tema.navn }}</mat-option>
      }
    </mat-optgroup>
  }
</mat-select>
